module.exports = __webpack_public_path__ + "img/RMR Store.2cbfe12a.png";